/**
 * PERFUME CUSTOMIZER CONFIGURATION
 * Icons and Fonts configuration for the customizer
 */

// ============================================================================
// ICON CONFIGURATION
// ============================================================================

const CUSTOMIZER_ICONS = {
    "Holidays": {
        "Christmas": {
            displayName: "Christmas",
            icons: [
                "icon-christmas-2-221.svg",
                "icon-christmas-2-249.svg",
                "icon-christmas-2-252.svg",
                "icon-christmas-2-253.svg",
                "icon-christmas-2-283.svg",
                "icon-christmas-2-284.svg",
                "icon-christmas-2-285.svg",
                "icon-christmas-2-296.svg",
                "icon-christmas-2-315.svg"
            ]
        },
        "Hanukkah": {
            displayName: "Hanukkah",
            icons: [
                "icon-hanukkah-2-111.svg",
                "icon-hanukkah-2-223.svg",
                "icon-hanukkah-2-237.svg",
                "icon-hanukkah-2-239.svg",
                "icon-hanukkah-2-240.svg",
                "icon-hanukkah-2-241.svg",
                "icon-hanukkah-2-261.svg",
                "icon-hanukkah-2-268.svg",
                "icon-hanukkah-2-273.svg",
                "icon-hanukkah-2-279.svg",
                "icon-hanukkah-2-320.svg"
            ]
        },
        "Eid": {
            displayName: "Eid",
            icons: [
                "icon-eid-2-220.svg",
                "icon-eid-2-226.svg",
                "icon-eid-2-251.svg",
                "icon-eid-2-275.svg",
                "icon-eid-2-277.svg",
                "icon-eid-2-305.svg",
                "icon-eid-2-316.svg",
                "icon-eid-2-331.svg"
            ]
        },
        "New Year": {
            displayName: "New Year",
            icons: [
                "icon-new-year-2-14.svg",
                "icon-new-year-2-238.svg",
                "icon-new-year-2-257.svg",
                "icon-new-year-2-265.svg",
                "icon-new-year-2-269.svg",
                "icon-new-year-2-270.svg",
                "icon-new-year-2-308.svg"
            ]
        }
    },

    "Occasions & Celebrations": {
        "Valentine's Day": {
            displayName: "Valentine's Day",
            icons: [
                "icon-valentines-day-1 copy-01-01.svg",
                "icon-valentines-day-2-02.svg",
                "icon-valentines-day-2-131.svg",
                "icon-valentines-day-2-155.svg",
                "icon-valentines-day-2-157.svg",
                "icon-valentines-day-2-177.svg",
                "icon-valentines-day-2-197.svg",
                "icon-valentines-day-2-200.svg",
                "icon-valentines-day-2-21.svg",
                "icon-valentines-day-2-211.svg",
                "icon-valentines-day-2-227.svg",
                "icon-valentines-day-2-280.svg",
                "icon-valentines-day-2-29.svg",
                "icon-valentines-day-2-76.svg",
                "icon-valentines-day-2-89.svg"
            ]
        },
        "Mother's Day": {
            displayName: "Mother's Day",
            icons: [
                "icon-mothers-day-1 copy-01 copy-01.svg",
                "icon-mothers-day-1 copy-01-01.svg",
                "icon-mothers-day-2-01 copy.svg",
                "icon-mothers-day-2-01.svg",
                "icon-mothers-day-2-03.svg",
                "icon-mothers-day-2-04.svg",
                "icon-mothers-day-2-119.svg",
                "icon-mothers-day-2-32.svg",
                "icon-mothers-day-2-35.svg"
            ]
        },
        "Father's Day": {
            displayName: "Father's Day",
            icons: [
                "icon-fathers-day-2-05.svg",
                "icon-fathers-day-2-06.svg",
                "icon-fathers-day-2-07.svg",
                "icon-fathers-day-2-63.svg",
                "icon-fathers-day-2-65.svg"
            ]
        },
        "Happy Birthday": {
            displayName: "Happy Birthday",
            icons: [
                "icon-happy-birthday-2-218.svg",
                "icon-happy-birthday-2-274.svg",
                "icon-happy-birthday-2-282.svg",
                "icon-happy-birthday-2-287.svg",
                "icon-happy-birthday-2-293.svg",
                "icon-happy-birthday-2-318.svg",
                "icon-happy-birthday-2-324.svg",
                "icon-happy-birthday-2-329.svg",
                "icon-happy-birthday-2-330.svg"
            ]
        },
        "Baby Shower": {
            displayName: "Baby Shower",
            icons: [
                "icon-baby-shower-1 copy-01.svg",
                "icon-baby-shower-2-36.svg",
                "icon-baby-shower-2-37.svg",
                "icon-baby-shower-2-39.svg",
                "icon-baby-shower-2-55.svg"
            ]
        },
        "Quinceañera": {
            displayName: "Quinceañera",
            icons: [
                "icon-quinceanera-15-2-125.svg",
                "icon-quinceanera-15-2-130.svg",
                "icon-quinceanera-15-2-141.svg",
                "icon-quinceanera-15-2-152.svg",
                "icon-quinceanera-15-2-154.svg",
                "icon-quinceanera-15-2-162.svg",
                "icon-quinceanera-15-2-163.svg",
                "icon-quinceanera-15-2-174.svg",
                "icon-quinceanera-15-2-185.svg",
                "icon-quinceanera-15-2-187.svg",
                "icon-quinceanera-15-2-198.svg",
                "icon-quinceanera-15-2-199.svg",
                "icon-quinceanera-15-2-210.svg",
                "icon-quinceanera-15-2-234.svg",
                "icon-quinceanera-15-2-81.svg",
                "icon-quinceanera-15-2-83.svg",
                "icon-quinceanera-15-2-87.svg",
                "icon-quinceanera-15-2-88.svg"
            ]
        },
        "Bar/Bat Mitzvah": {
            displayName: "Bar/Bat Mitzvah",
            icons: [
                "icon-bat-bar-mitzvah-2-114.svg",
                "icon-bat-bar-mitzvah-2-146.svg",
                "icon-bat-bar-mitzvah-2-147.svg",
                "icon-bat-bar-mitzvah-2-182.svg",
                "icon-bat-bar-mitzvah-2-23.svg",
                "icon-bat-bar-mitzvah-2-233.svg",
                "icon-bat-bar-mitzvah-2-24.svg",
                "icon-bat-bar-mitzvah-2-25.svg",
                "icon-bat-bar-mitzvah-2-258.svg",
                "icon-bat-bar-mitzvah-2-263.svg",
                "icon-bat-bar-mitzvah-2-264.svg",
                "icon-bat-bar-mitzvah-2-276.svg",
                "icon-bat-bar-mitzvah-2-312.svg",
                "icon-bat-bar-mitzvah-2-313.svg",
                "icon-bat-bar-mitzvah-2-54.svg",
                "icon-bat-bar-mitzvah-2-56.svg"
            ]
        }
    },

    "Wedding Collection": {
        "Wedding": {
            displayName: "Wedding",
            icons: [
                "icon-wedding-2-117.svg",
                "icon-wedding-2-178.svg",
                "icon-wedding-2-183.svg",
                "icon-wedding-2-224.svg",
                "icon-wedding-2-228.svg",
                "icon-wedding-2-242.svg",
                "icon-wedding-2-245.svg",
                "icon-wedding-2-246.svg",
                "icon-wedding-2-247.svg",
                "icon-wedding-2-248.svg",
                "icon-wedding-2-260.svg",
                "icon-wedding-2-266.svg",
                "icon-wedding-2-271.svg",
                "icon-wedding-2-292.svg",
                "icon-wedding-2-303.svg",
                "icon-wedding-2-31.svg",
                "icon-wedding-2-310.svg",
                "icon-wedding-2-311.svg",
                "icon-wedding-2-328.svg",
                "icon-wedding-2-332.svg",
                "icon-wedding-2-61.svg",
                "icon-wedding-2-66.svg",
                "icon-wedding-2-68.svg",
                "icon-wedding-2-71.svg",
                "icon-wedding-2-73.svg"
            ]
        },
        "Bachelorette Party": {
            displayName: "Bachelorette Party",
            icons: [
                "icon-bachelorette-party-2-105.svg",
                "icon-bachelorette-party-2-107.svg",
                "icon-bachelorette-party-2-109.svg",
                "icon-bachelorette-party-2-110.svg",
                "icon-bachelorette-party-2-160.svg",
                "icon-bachelorette-party-2-179.svg",
                "icon-bachelorette-party-2-222.svg",
                "icon-bachelorette-party-2-229.svg",
                "icon-bachelorette-party-2-235.svg",
                "icon-bachelorette-party-2-262.svg",
                "icon-bachelorette-party-2-278.svg",
                "icon-bachelorette-party-2-286.svg",
                "icon-bachelorette-party-2-294.svg",
                "icon-bachelorette-party-2-306.svg",
                "icon-bachelorette-party-2-59.svg"
            ]
        },
        "Best Man": {
            displayName: "Best Man",
            icons: [
                "icon-best-man-2-100.svg",
                "icon-best-man-2-101.svg",
                "icon-best-man-2-102.svg",
                "icon-best-man-2-106.svg",
                "icon-best-man-2-108.svg",
                "icon-best-man-2-112.svg",
                "icon-best-man-2-142.svg",
                "icon-best-man-2-181.svg",
                "icon-best-man-2-213.svg",
                "icon-best-man-2-28.svg",
                "icon-best-man-2-301.svg",
                "icon-best-man-2-302.svg",
                "icon-best-man-2-314.svg",
                "icon-best-man-2-60.svg",
                "icon-best-man-2-64.svg",
                "icon-best-man-2-67.svg",
                "icon-best-man-2-70.svg"
            ]
        }
    },

    "Family": {
        "Family": {
            displayName: "Family",
            icons: [
                "icon-family-2-12.svg",
                "icon-family-2-16.svg",
                "icon-family-2-17.svg"
            ]
        },
        "Sisters": {
            displayName: "Sisters",
            icons: [
                "icon-sisters-2-122.svg",
                "icon-sisters-2-127.svg",
                "icon-sisters-2-145.svg",
                "icon-sisters-2-148.svg",
                "icon-sisters-2-150.svg",
                "icon-sisters-2-188.svg",
                "icon-sisters-2-189.svg",
                "icon-sisters-2-255.svg",
                "icon-sisters-2-288.svg",
                "icon-sisters-2-291.svg",
                "icon-sisters-2-74.svg",
                "icon-sisters-2-77.svg",
                "icon-sisters-2-78.svg",
                "icon-sisters-2-96.svg"
            ]
        },
        "Brother": {
            displayName: "Brother",
            icons: [
                "icon-brother-2-103.svg",
                "icon-brother-2-144.svg",
                "icon-brother-2-149.svg",
                "icon-brother-2-176.svg",
                "icon-brother-2-236.svg",
                "icon-brother-2-267.svg",
                "icon-brother-2-75.svg",
                "icon-brother-2-79.svg"
            ]
        },
        "Grandma/Grandpa": {
            displayName: "Grandma/Grandpa",
            icons: [
                "icon-grandpa-grandma-2-116.svg",
                "icon-grandpa-grandma-2-118.svg",
                "icon-grandpa-grandma-2-13.svg",
                "icon-grandpa-grandma-2-143.svg",
                "icon-grandpa-grandma-2-173.svg",
                "icon-grandpa-grandma-2-19.svg",
                "icon-grandpa-grandma-2-46.svg",
                "icon-grandpa-grandma-2-48.svg",
                "icon-grandpa-grandma-2-52.svg"
            ]
        }
    },

    "Friends & Connections": {
        "Besties": {
            displayName: "Besties",
            icons: [
                "icon-besties-bff-2-151.svg",
                "icon-besties-bff-2-256.svg",
                "icon-besties-bff-2-300.svg",
                "icon-besties-bff-2-304.svg",
                "icon-besties-bff-2-321.svg",
                "icon-besties-bff-2-322.svg",
                "icon-besties-bff-2-326.svg",
                "icon-besties-bff-2-327.svg",
                "icon-besties-bff-2-95.svg"
            ]
        },
        "Teenager": {
            displayName: "Teenager",
            icons: [
                "icon-teenagers-2-137.svg",
                "icon-teenagers-2-156.svg",
                "icon-teenagers-2-158.svg",
                "icon-teenagers-2-161.svg",
                "icon-teenagers-2-168.svg",
                "icon-teenagers-2-171.svg",
                "icon-teenagers-2-172.svg",
                "icon-teenagers-2-191.svg",
                "icon-teenagers-2-192.svg",
                "icon-teenagers-2-193.svg",
                "icon-teenagers-2-203.svg",
                "icon-teenagers-2-205.svg",
                "icon-teenagers-2-209.svg",
                "icon-teenagers-2-309.svg",
                "icon-teenagers-2-80.svg",
                "icon-teenagers-2-93.svg",
                "icon-girl-2-180.svg",
                "icon-music-2-126.svg",
                "icon-music-2-153.svg",
                "icon-music-2-82.svg",
                "icon-sports-2-135.svg",
                "icon-sports-2-136.svg"
            ]
        },
        "General Symbols": {
            displayName: "General Symbols",
            icons: [
                "icon-other-2-104.svg",
                "icon-other-2-124.svg",
                "icon-other-2-129.svg",
                "icon-other-2-138.svg",
                "icon-other-2-139.svg",
                "icon-other-2-164.svg",
                "icon-other-2-169.svg",
                "icon-other-2-175.svg",
                "icon-other-2-207.svg",
                "icon-other-2-230.svg",
                "icon-other-2-232.svg",
                "icon-other-2-243.svg",
                "icon-other-2-250.svg",
                "icon-other-2-272.svg",
                "icon-other-2-281.svg",
                "icon-other-2-298.svg",
                "icon-other-2-307.svg",
                "icon-other-2-317.svg",
                "icon-other-2-319.svg",
                "icon-other-2-34.svg",
                "icon-other-2-62.svg",
                "icon-other-2-72.svg"
            ]
        }
    },

    "Work & Leadership": {
        "Boss Lady/Boss Men": {
            displayName: "Boss Lady/Boss Men",
            icons: [
                "icon-boss-2-113.svg",
                "icon-boss-2-115.svg",
                "icon-boss-2-184.svg",
                "icon-boss-2-186.svg",
                "icon-boss-2-225.svg",
                "icon-boss-2-244.svg",
                "icon-boss-2-295.svg",
                "icon-boss-2-299.svg",
                "icon-boss-2-69.svg"
            ]
        },
        "Work / Teamwork": {
            displayName: "Work / Teamwork",
            icons: [
                "icon-work-teamwork-2-09.svg",
                "icon-work-teamwork-2-11.svg",
                "icon-work-teamwork-2-15.svg",
                "icon-work-teamwork-2-165.svg",
                "icon-work-teamwork-2-49.svg",
                "icon-team-business-2-08.svg",
                "icon-team-business-2-10.svg",
                "icon-team-business-2-204.svg",
                "icon-team-business-2-212.svg",
                "icon-team-business-2-231.svg",
                "icon-team-business-2-254.svg",
                "icon-team-business-2-290.svg",
                "icon-team-business-2-297.svg",
                "icon-team-business-2-323.svg",
                "icon-team-business-2-325.svg",
                "icon-team-business-2-40.svg",
                "icon-team-business-2-41.svg",
                "icon-team-business-2-43.svg",
                "icon-team-business-2-51.svg"
            ]
        }
    },

    "Travel": {
        "Traveler": {
            displayName: "Traveler",
            icons: [
                "icon-travel-2-120.svg",
                "icon-travel-2-121.svg",
                "icon-travel-2-123.svg",
                "icon-travel-2-128.svg",
                "icon-travel-2-132.svg",
                "icon-travel-2-133.svg",
                "icon-travel-2-134.svg",
                "icon-travel-2-159.svg",
                "icon-travel-2-166.svg",
                "icon-travel-2-190.svg",
                "icon-travel-2-194.svg",
                "icon-travel-2-195.svg",
                "icon-travel-2-196.svg",
                "icon-travel-2-202.svg",
                "icon-travel-2-206.svg",
                "icon-travel-2-289.svg",
                "icon-travel-2-58.svg",
                "icon-travel-2-84.svg",
                "icon-travel-2-85.svg",
                "icon-travel-2-86.svg",
                "icon-travel-2-90.svg",
                "icon-travel-2-91.svg",
                "icon-travel-2-92.svg"
            ]
        }
    },

    "Appreciation": {
        "Thank You": {
            displayName: "Thank You",
            icons: [
                "icon-thank-you-2-140.svg",
                "icon-thank-you-2-167.svg",
                "icon-thank-you-2-170.svg",
                "icon-thank-you-2-201.svg",
                "icon-thank-you-2-208.svg",
                "icon-thank-you-2-57.svg",
                "icon-thank-you-2-94.svg",
                "icon-thank-you-2-97.svg",
                "icon-thank-you-2-98.svg",
                "icon-thank-you-2-99.svg"
            ]
        }
    }
};

// ============================================================================
// FONT CONFIGURATION
// ============================================================================

const CUSTOMIZER_FONTS = {
    english: [
        { name: "Tilt Prism", family: "TiltPrism-Regular-VariableFont_XROT_YROT, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/TiltPrism-Regular-VariableFont_XROT_YROT.ttf?v=1763132779" },
        { name: "Loud Beats", family: "LoudBeats, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/LoudBeats.ttf?v=1763132779" },
        { name: "Fredericka the Great", family: "FrederickatheGreat-Regular, Georgia, serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/FrederickatheGreat-Regular.ttf?v=1763132779" },
        { name: "Bavaria Gates", family: "Bavaria_Gates, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Bavaria_Gates.otf?v=1763132778" },
        { name: "Cinzel", family: "Cinzel-VariableFont_wght, Georgia, serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Cinzel-VariableFont_wght.ttf?v=1763132778" },
        { name: "Homemade Apple", family: "HomemadeApple-Regular, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/HomemadeApple-Regular.ttf?v=1763132778" },
        { name: "Scrabbles", family: "Scrabbles, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Scrabbles.ttf?v=1763132779" },
        { name: "Syncopate", family: "Syncopate-Regular, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Syncopate-Regular.ttf?v=1763132778" },
        { name: "PopArt", family: "PopArt-Regular, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/PopArt-Regular.ttf?v=1763132778" },
        { name: "Henny Penny", family: "HennyPenny-Regular, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/HennyPenny-Regular.ttf?v=1763132778" },
        { name: "Musicografi", family: "Musicografi, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Musicografi.ttf?v=1763132778" },
        { name: "Cherl", family: "CHERL, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/CHERL.TTF?v=1763132778" },
        { name: "Hello Monogram", family: "HelloMonogram, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/HelloMonogram.ttf?v=1763132778" },
        { name: "Syncopate Bold", family: "Syncopate-Bold, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Syncopate-Bold.ttf?v=1763132778" },
        { name: "Namecat", family: "Namecat, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Namecat.ttf?v=1763132778" },
        { name: "Mickey", family: "MICKEY, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/MICKEY.TTF?v=1763132778" },
        { name: "Here We Go Rodeo", family: "HereWeGoRodeo-Regular, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/HereWeGoRodeo-Regular.ttf?v=1763132778" },
        { name: "Marcsc", family: "Marcsc, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Marcsc.ttf?v=1763132778" },
        { name: "Minnie", family: "Minnie, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Minnie.TTF?v=1763132778" },
        { name: "Cheri", family: "CHERI, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/CHERI.TTF?v=1763132777" }
    ],

    hebrew: [
        { name: "Horev CLM Heavy", family: "Horev_CLM_Heavy, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Horev_CLM_Heavy.ttf?v=1763213449" },
        { name: "Alef Bold", family: "Alef-Bold, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Alef-Bold.ttf?v=1763213651" },
        { name: "Varela Round", family: "VarelaRound-Regular, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/VarelaRound-Regular.ttf?v=1763213651" },
        { name: "Noto Serif", family: "NotoSerif-VariableFont_wdth_wght, Georgia, serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/NotoSerif-VariableFont_wdth_wght.ttf?v=1763213651" }
    ],

    arabic: [
        { name: "Tajawal Bold", family: "Tajawal-Bold, Arial Arabic, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Tajawal-Bold.ttf?v=1763213790" },
        { name: "Amiri Bold", family: "Amiri-Bold, Amiri, serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Amiri-Bold.ttf?v=1763213791" },
        { name: "Scheherazade New Bold", family: "ScheherazadeNew-Bold, Tahoma, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/ScheherazadeNew-Bold.ttf?v=1763213791" }
    ],

    french: [
        { name: "Tilt Prism", family: "TiltPrism-Regular-VariableFont_XROT_YROT, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/TiltPrism-Regular-VariableFont_XROT_YROT.ttf?v=1763132779" },
        { name: "Loud Beats", family: "LoudBeats, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/LoudBeats.ttf?v=1763132779" },
        { name: "Fredericka the Great", family: "FrederickatheGreat-Regular, Georgia, serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/FrederickatheGreat-Regular.ttf?v=1763132779" },
        { name: "Bavaria Gates", family: "Bavaria_Gates, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Bavaria_Gates.otf?v=1763132778" },
        { name: "Cinzel", family: "Cinzel-VariableFont_wght, Georgia, serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Cinzel-VariableFont_wght.ttf?v=1763132778" },
        { name: "Homemade Apple", family: "HomemadeApple-Regular, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/HomemadeApple-Regular.ttf?v=1763132778" },
        { name: "Scrabbles", family: "Scrabbles, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Scrabbles.ttf?v=1763132779" },
        { name: "Syncopate", family: "Syncopate-Regular, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Syncopate-Regular.ttf?v=1763132778" },
        { name: "PopArt", family: "PopArt-Regular, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/PopArt-Regular.ttf?v=1763132778" },
        { name: "Henny Penny", family: "HennyPenny-Regular, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/HennyPenny-Regular.ttf?v=1763132778" },
        { name: "Musicografi", family: "Musicografi, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Musicografi.ttf?v=1763132778" },
        { name: "Cherl", family: "CHERL, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/CHERL.TTF?v=1763132778" },
        { name: "Hello Monogram", family: "HelloMonogram, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/HelloMonogram.ttf?v=1763132778" },
        { name: "Syncopate Bold", family: "Syncopate-Bold, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Syncopate-Bold.ttf?v=1763132778" },
        { name: "Namecat", family: "Namecat, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Namecat.ttf?v=1763132778" },
        { name: "Mickey", family: "MICKEY, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/MICKEY.TTF?v=1763132778" },
        { name: "Here We Go Rodeo", family: "HereWeGoRodeo-Regular, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/HereWeGoRodeo-Regular.ttf?v=1763132778" },
        { name: "Marcsc", family: "Marcsc, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Marcsc.ttf?v=1763132778" },
        { name: "Minnie", family: "Minnie, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Minnie.TTF?v=1763132778" },
        { name: "Cheri", family: "CHERI, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/CHERI.TTF?v=1763132777" }
    ],

    spanish: [
        { name: "Tilt Prism", family: "TiltPrism-Regular-VariableFont_XROT_YROT, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/TiltPrism-Regular-VariableFont_XROT_YROT.ttf?v=1763132779" },
        { name: "Loud Beats", family: "LoudBeats, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/LoudBeats.ttf?v=1763132779" },
        { name: "Fredericka the Great", family: "FrederickatheGreat-Regular, Georgia, serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/FrederickatheGreat-Regular.ttf?v=1763132779" },
        { name: "Bavaria Gates", family: "Bavaria_Gates, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Bavaria_Gates.otf?v=1763132778" },
        { name: "Cinzel", family: "Cinzel-VariableFont_wght, Georgia, serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Cinzel-VariableFont_wght.ttf?v=1763132778" },
        { name: "Homemade Apple", family: "HomemadeApple-Regular, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/HomemadeApple-Regular.ttf?v=1763132778" },
        { name: "Scrabbles", family: "Scrabbles, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Scrabbles.ttf?v=1763132779" },
        { name: "Syncopate", family: "Syncopate-Regular, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Syncopate-Regular.ttf?v=1763132778" },
        { name: "PopArt", family: "PopArt-Regular, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/PopArt-Regular.ttf?v=1763132778" },
        { name: "Henny Penny", family: "HennyPenny-Regular, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/HennyPenny-Regular.ttf?v=1763132778" },
        { name: "Musicografi", family: "Musicografi, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Musicografi.ttf?v=1763132778" },
        { name: "Cherl", family: "CHERL, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/CHERL.TTF?v=1763132778" },
        { name: "Hello Monogram", family: "HelloMonogram, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/HelloMonogram.ttf?v=1763132778" },
        { name: "Syncopate Bold", family: "Syncopate-Bold, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Syncopate-Bold.ttf?v=1763132778" },
        { name: "Namecat", family: "Namecat, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Namecat.ttf?v=1763132778" },
        { name: "Mickey", family: "MICKEY, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/MICKEY.TTF?v=1763132778" },
        { name: "Here We Go Rodeo", family: "HereWeGoRodeo-Regular, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/HereWeGoRodeo-Regular.ttf?v=1763132778" },
        { name: "Marcsc", family: "Marcsc, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Marcsc.ttf?v=1763132778" },
        { name: "Minnie", family: "Minnie, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/Minnie.TTF?v=1763132778" },
        { name: "Cheri", family: "CHERI, Arial, sans-serif", type: "custom", url: "https://cdn.shopify.com/s/files/1/0946/4859/8826/files/CHERI.TTF?v=1763132777" }
    ],

    chinese: [
        { name: "SimSun", family: "SimSun, serif", type: "system" },
        { name: "Microsoft YaHei", family: "Microsoft YaHei, sans-serif", type: "system" }
    ],

    russian: [
        { name: "Arial Cyrillic", family: "Arial, sans-serif", type: "system" },
        { name: "Times New Roman Cyrillic", family: "Times New Roman, serif", type: "system" }
    ]
};

// Export to window for use in customizer
window.CUSTOMIZER_ICONS = CUSTOMIZER_ICONS;
window.CUSTOMIZER_FONTS = CUSTOMIZER_FONTS;
